import React from 'react';
import { ContextLoader } from "../components/ContextLoader";

const RouteLoading = () => (<ContextLoader isLoading={true}/>);

export { RouteLoading }
